import { cn } from "@/lib/utils";

/**
 * A horizontal rail of the series page (Cast, BTS, Recommendations): bleeds
 * into the mobile gutter and snaps, static from `md`. `itemClassName` sets
 * the items' widths; the skeletons pass `static` to drop the scrolling.
 */
const SeriesRail: React.FC<{
  itemClassName: string;
  static?: boolean;
  children: React.ReactNode;
}> = ({ itemClassName, static: isStatic = false, children }) => (
  <div
    className={cn(
      "-mx-4 flex px-4 *:shrink-0 md:mx-0 md:px-0",
      isStatic
        ? "overflow-hidden"
        : "snap-x scroll-px-4 [scrollbar-width:none] overflow-x-auto *:snap-start",
      itemClassName,
    )}
  >
    {children}
  </div>
);

export default SeriesRail;
